export const RECORDS_TO_SHOW_PER_PAGE = 20;
